<div class="modal-header">
	<h1 class="modal-title">
		Assign Students
		<div class="modal-subtitle">
			{{ subtitle() }}
		</div>
	</h1>

	<button
		class="btn btn-outline-dark"
		title="Close"
		type="button"
		(click)="activeModal.dismiss()"
	>
		<i aria-hidden="true" class="far fa-times"></i>
	</button>
</div>
<div class="modal-body p-0">
	<ae-pgt
		#t
		name="Assign Students"
		tableClass="table-striped table-hover p-3"
		[tableConfig]="tableConfig"
	>
		<ae-pgt-column columnId="uid" [isAuxiliary]="true">
			<ng-template aePgtHeader>Student ID</ng-template>
			<ng-template let-item [aePgtDisplay]="t">{{
				item.uid | ifEmpty
			}}</ng-template>
			<ng-template let-form [aePgtSearch]="t">
				<ae-equality-comparer-number-input
					class="m-0"
					id="assign.students.modal.component.table.uid"
					[formControl]="form.controls.uid"
			/></ng-template>
		</ae-pgt-column>

		<ae-pgt-column columnId="first_name" [isDefault]="true">
			<ng-template aePgtHeader>First Name</ng-template>
			<ng-template let-item [aePgtDisplay]="t">{{
				item.first_name | ifEmpty
			}}</ng-template>
			<ng-template let-form [aePgtSearch]="t">
				<input
					class="form-control"
					id="assign.students.modal.component.table.first_name"
					title="Search by First Name"
					type="search"
					[formControl]="form.controls.first_name"
				/>
			</ng-template>
		</ae-pgt-column>

		<ae-pgt-column columnId="last_name" [isDefault]="true">
			<ng-template aePgtHeader>Last Name</ng-template>
			<ng-template let-item [aePgtDisplay]="t">{{
				item.last_name | ifEmpty
			}}</ng-template>
			<ng-template let-form [aePgtSearch]="t">
				<input
					class="form-control"
					id="assign.students.modal.component.table.last_name"
					title="Search by Last Name"
					type="search"
					[formControl]="form.controls.last_name"
				/>
			</ng-template>
		</ae-pgt-column>

		<ae-pgt-column columnId="middle_name" [isAuxiliary]="true">
			<ng-template aePgtHeader>Middle Name</ng-template>
			<ng-template let-item [aePgtDisplay]="t">{{
				item.middle_name | ifEmpty
			}}</ng-template>
			<ng-template let-form [aePgtSearch]="t">
				<input
					class="form-control"
					id="assign.students.modal.component.table.middle_name"
					title="Search by Middle Name"
					type="search"
					[formControl]="form.controls.middle_name"
				/>
			</ng-template>
		</ae-pgt-column>

		<ae-pgt-column columnId="suffix_name" [isAuxiliary]="true">
			<ng-template aePgtHeader>Suffix Name</ng-template>
			<ng-template let-item [aePgtDisplay]="t">{{
				item.suffix_name | ifEmpty
			}}</ng-template>
			<ng-template let-form [aePgtSearch]="t">
				<input
					class="form-control"
					id="assign.students.modal.component.table.suffix_name"
					title="Search by Suffix"
					type="search"
					[formControl]="form.controls.suffix_name"
				/>
			</ng-template>
		</ae-pgt-column>

		<ae-pgt-column columnId="maiden_name" [isAuxiliary]="true">
			<ng-template aePgtHeader>Maiden Name</ng-template>
			<ng-template let-item [aePgtDisplay]="t">{{
				item.maiden_name | ifEmpty
			}}</ng-template>
			<ng-template let-form [aePgtSearch]="t">
				<input
					class="form-control"
					id="assign.students.modal.component.table.maiden_name"
					title="Search by Maiden Name"
					type="search"
					[formControl]="form.controls.maiden_name"
				/>
			</ng-template>
		</ae-pgt-column>

		<ae-pgt-column columnId="birthdate" [isDefault]="true">
			<ng-template aePgtHeader>Birthdate</ng-template>
			<ng-template let-item [aePgtDisplay]="t">{{
				item.birthdate | date: 'MM/dd/yyyy' | ifEmpty
			}}</ng-template>
			<ng-template let-form [aePgtSearch]="t">
				<ae-equality-comparer-date
					class="m-0"
					id="assign.students.modal.component.table.birthdate"
					[formControl]="form.controls.birthdate"
				/>
			</ng-template>
		</ae-pgt-column>

		<ae-pgt-column columnId="race" [isAuxiliary]="true">
			<ng-template aePgtHeader>Race</ng-template>
			<ng-template let-item [aePgtDisplay]="t">{{
				item.race | ifEmpty
			}}</ng-template>
			<ng-template let-form [aePgtSearch]="t">
				<input
					class="form-control"
					id="assign.students.modal.component.table.race"
					title="Search by Race"
					type="search"
					[formControl]="form.controls.race"
				/>
			</ng-template>
		</ae-pgt-column>

		<ae-pgt-column columnId="gender" [isAuxiliary]="true">
			<ng-template aePgtHeader>Gender</ng-template>
			<ng-template let-item [aePgtDisplay]="t">{{
				item.gender | ifEmpty
			}}</ng-template>
			<ng-template let-form [aePgtSearch]="t">
				<input
					class="form-control"
					id="assign.students.modal.component.table.gender"
					title="Search by Gender"
					type="search"
					[formControl]="form.controls.gender"
				/>
			</ng-template>
		</ae-pgt-column>

		<ae-pgt-column columnId="account_email" [isAuxiliary]="true">
			<ng-template aePgtHeader>Account Email</ng-template>
			<ng-template let-item [aePgtDisplay]="t">{{
				item.account_email | ifEmpty
			}}</ng-template>
			<ng-template let-form [aePgtSearch]="t">
				<input
					class="form-control"
					id="assign.students.modal.component.table.account_email"
					title="Search by Account Email"
					type="search"
					[formControl]="form.controls.account_email"
				/>
			</ng-template>
		</ae-pgt-column>

		<ae-pgt-column columnId="has_activated_date" [isAuxiliary]="true">
			<ng-template aePgtHeader>Is Activated</ng-template>
			<ng-template let-item [aePgtDisplay]="t">{{
				item.has_activated_date ? 'Yes' : 'No'
			}}</ng-template>
			<ng-template let-form [aePgtSearch]="t">
				<ae-yes-no-select [formControl]="form.controls.has_activated_date" />
			</ng-template>
		</ae-pgt-column>

		<ae-pgt-column columnId="institute_title" [isDefault]="true">
			<ng-template aePgtHeader>Program</ng-template>
			<ng-template let-item [aePgtDisplay]="t">{{
				item.institute_title | ifEmpty
			}}</ng-template>
			<ng-template let-form [aePgtSearch]="t">
				<input
					class="form-control"
					id="assign.students.modal.component.table.institute_title"
					title="Search by Program"
					type="search"
					[formControl]="form.controls.institute_title"
				/>
			</ng-template>
		</ae-pgt-column>

		<ae-pgt-column columnId="itype" [isAuxiliary]="true">
			<ng-template aePgtHeader>Program Type</ng-template>
			<ng-template let-item [aePgtDisplay]="t">{{
				item.itype | ifEmpty
			}}</ng-template>
			<ng-template let-form [aePgtSearch]="t">
				<input
					class="form-control"
					id="assign.students.modal.component.table.itype"
					title="Search by Program Type"
					type="search"
					[formControl]="form.controls.itype"
				/>
			</ng-template>
		</ae-pgt-column>

		<ae-pgt-column columnId="state" [isDefault]="true">
			<ng-template aePgtHeader>State</ng-template>
			<ng-template let-item [aePgtDisplay]="t">{{
				item.state | ifEmpty
			}}</ng-template>
			<ng-template let-form [aePgtSearch]="t">
				<input
					class="form-control"
					id="assign.students.modal.component.table.state"
					title="Search by Program"
					type="search"
					[formControl]="form.controls.state"
				/>
			</ng-template>
		</ae-pgt-column>

		<ae-pgt-column columnId="reported_grade" [isDefault]="true">
			<ng-template aePgtHeader>Grade</ng-template>
			<ng-template let-item [aePgtDisplay]="t">{{
				item.reported_grade | ifEmpty
			}}</ng-template>
			<ng-template let-form [aePgtSearch]="t">
				<input
					class="form-control"
					id="assign.students.modal.component.table.reported_grade"
					title="Search by Program"
					type="search"
					[formControl]="form.controls.reported_grade"
				/>
			</ng-template>
		</ae-pgt-column>

		<ae-pgt-column columnId="currently_enrolled" [isAuxiliary]="true">
			<ng-template aePgtHeader>Is Enrolled</ng-template>
			<ng-template let-item [aePgtDisplay]="t">{{
				item.currently_enrolled ? 'Yes' : 'No'
			}}</ng-template>
			<ng-template let-form [aePgtSearch]="t">
				<ae-yes-no-select [formControl]="form.controls.currently_enrolled" />
			</ng-template>
		</ae-pgt-column>
	</ae-pgt>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="activeModal.dismiss()">
		Cancel
	</button>

	@let keys = this.tableApi?.getSelectedKeys() ?? null;
	<button
		class="btn btn-primary"
		type="button"
		[disabled]="keys?.length < 1 || loading"
		(click)="activeModal.close(keys)"
	>
		Assign {{ keys?.length < 1 ? '' : keys.length }} Students
	</button>
</div>
